import { callApiToServer } from '../callApi';

export async function changeFeatureStatus(
  authtoken,
  cardId,
  status
) {
  try{
    let header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      "authorization" : "Berear " + authtoken
    };
      
    let body = JSON.stringify({
        cardId: cardId,
        flag: status
    });

    let endUrl = "v1/auth/change-card-feature-status";
    console.log("endUrl printed here", endUrl);
  
    let responseData = await callApiToServer(body, header, "POST", endUrl);
      
    return responseData;
  }catch(err) {
    throw err;
  }
}
